import http from "../axios/http-common";
import type { ToothExam } from "@/types/odontogram";

class InterfaceToothExam {
  listValues() {
    return http.getData(`/tooth-exam-values`);
  }

  getByEncounter(encounterId: string) {
    return http.getData(`/tooth-exams/encounter/${encounterId}`);
  }

  syncByEncounter(encounterId: string, toothExams: ToothExam[]) {
    const payload = toothExams.map((e) => ({
      tooth_id: e.tooth_id,
      tooth_surface_id: e.tooth_surface_id,
      value_id: e.value_id
    }));

    return http.putData(`/tooth-exams/encounter/${encounterId}`, {
      tooth_exams: payload
    });
  }
}

export default new InterfaceToothExam();
